import { createSlice } from '@reduxjs/toolkit';

const resetState = {
  showAppOverlay: false,
  selectedBooking: {},
  selectedQuote: {},
  latestBookings: {},
  latestQuotes: {},
  canvasQuoteDocuments: {},
  componentConfig: {},
  textConfig: {},
  showFeedbackBar: false,
  feedbackBarDetails: {
    error: false,
    message: '',
  },
  theme: {},
  loginCredentials: {},
  refreshAfterPaymentFlag: false,
  isInitialised: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    ...resetState,
    appType: '',
    showLoadingAppOverlay: false,
    loggedOutFromTimeout: false,
    whiteLabelSettings: {},
  },
  reducers: {
    toggleAppOverlay: (reduxState, { payload }) => {
      reduxState.showAppOverlay = payload;
    },
    toggleLoadingAppOverlay: (reduxState, { payload }) => {
      reduxState.showLoadingAppOverlay = payload;
    },
    setLoggedOutFromTimeout: (reduxState, { payload }) => {
      reduxState.loggedOutFromTimeout = payload;
    },
    setSelectedBooking: (reduxState, { payload }) => {
      reduxState.selectedBooking = payload || {};
    },
    setSelectedQuote: (reduxState, { payload }) => {
      reduxState.selectedQuote = payload || {};
    },
    setLatestBookings: (reduxState, { payload }) => {
      reduxState.latestBookings = payload || {};
    },
    setLatestQuotes: (reduxState, { payload }) => {
      reduxState.latestQuotes = payload || {};
    },
    setCanvasQuoteDocuments: (reduxState, { payload }) => {
      reduxState.canvasQuoteDocuments = payload || {};
    },
    setWhiteLabelSettings: (reduxState, { payload }) => {
      reduxState.whiteLabelSettings = payload || {};
    },
    setComponentConfig: (reduxState, { payload }) => {
      reduxState.componentConfig = payload || {};
    },
    setTextConfig: (reduxState, { payload }) => {
      reduxState.textConfig = payload || {};
    },
    toggleFeedbackBar: (reduxState, { payload }) => {
      reduxState.showFeedbackBar =
        typeof payload === 'boolean' ? payload : !reduxState.showFeedbackBar;
    },
    showErrorFeedbackBar: (reduxState, { payload }) => {
      reduxState.feedbackBarDetails = {
        error: true,
        message: payload || '',
      };
      reduxState.showFeedbackBar = true;
    },
    showSuccessFeedbackBar: (reduxState, { payload }) => {
      reduxState.feedbackBarDetails = {
        error: false,
        message: payload || '',
      };
      reduxState.showFeedbackBar = true;
    },
    setAppType: (reduxState, { payload = '' }) => {
      reduxState.appType = payload;
    },
    setTheme: (reduxState, { payload = '' }) => {
      reduxState.theme = payload;
    },
    setIsInitialised: (reduxState, { payload = '' }) => {
      reduxState.isInitialised = payload;
    },
    setLoginCredentials: (reduxState, { payload }) => {
      if (payload) {
        reduxState.loginCredentials = payload;
      }
    },
    setRefreshAfterPaymentFlag: (reduxState, { payload = '' }) => {
      reduxState.refreshAfterPaymentFlag = payload;
    },
    resetUISlice: (reduxState) => {
      Object.assign(reduxState, resetState);
    }, 
  },
});

export const {
  toggleAppOverlay,
  toggleLoadingAppOverlay,
  setLoggedOutFromTimeout,
  setSelectedBooking,
  setSelectedQuote,
  setLatestBookings,
  setLatestQuotes,
  setTextConfig,
  setCanvasQuoteDocuments,
  setWhiteLabelSettings,
  setComponentConfig,
  toggleFeedbackBar,
  showErrorFeedbackBar,
  showSuccessFeedbackBar,
  setAppType,
  setTheme,
  setIsInitialised,
  setLoginCredentials,
  setRefreshAfterPaymentFlag,
  resetUISlice,
} = uiSlice.actions;

export { resetState as uiResetState };

export default uiSlice.reducer;
